import Vue from 'vue'
import Router from 'vue-router'
import page from '@/views/home/page'
import detail from "../views/home/detail";
import standardSystem from "../views/home/standardSystem";
import standard from "../views/home/standard";
import standardStatistical from "../views/home/standardStatistical";
import about from "../views/home/about";
import tcAbout from "../views/home/tcAbout";
import mapping from "../views/home/mapping"
import standardExplain from "../views/home/standardExplain";
import fileDownLoad from "../views/home/fileDownLoad";
import policyExplain from "../views/home/policyExplain";
import system from "../views/home/system";
Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)

}


export default new Router({
  base:'/standard-portal',
  routes: [
    {
      path: '/',
      redirect:'home'
    },
    {
      path: '/home',
      name: 'home',
      component: page,
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/standardSystem',
      name: 'standardSystem',
      component: standardSystem
    },
    {
      path: '/standard',
      name: 'standard',
      component: standard
    },
    {
      path: '/standardStatistical',
      name: 'standardStatistical',
      component: standardStatistical
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/tcAbout',
      name: 'tcAbout',
      component: tcAbout
    },
    {
      path: '/mapping',
      name: 'mapping',
      component: mapping
    },
    {
      path: '/system',
      name: 'system',
      component: system
    },
    {
      path: '/standardExplain',
      name: 'standardExplain',
      component: standardExplain
    },
    {
      path: '/fileDownLoad',
      name: 'fileDownLoad',
      component: fileDownLoad
    },
    {
      path: '/policyExplain',
      name: 'policyExplain',
      component: policyExplain
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js